import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'leaflet/dist/leaflet.css';
import './index.css';
import App from './App.tsx';
import ErrorBoundary from './components/ErrorBoundary.tsx';

// Страницы грузятся отдельными файлами (lazy), у которых имя меняется на каждой сборке —
// если вкладка была открыта во время деплоя и пытается подгрузить уже удалённый старый
// чанк, Vite сообщает об этом именно так. Раньше это приводило к белому экрану без единой
// ошибки в интерфейсе — просто перезагружаем страницу, чтобы подтянуть актуальный index.html
// и текущие файлы. Флаг в sessionStorage — чтобы не зациклиться, если сеть реально недоступна
const CHUNK_RELOAD_KEY = 'chunk-reload-attempted';
// Раз мы дошли до этой строки — текущий бандл точно загрузился успешно, снимаем флаг,
// чтобы следующий реальный сбой снова мог вызвать одну перезагрузку, а не молчать вечно
sessionStorage.removeItem(CHUNK_RELOAD_KEY);
window.addEventListener('vite:preloadError', () => {
  if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    window.location.reload();
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
